module.exports = __webpack_public_path__ + "RobotoLight.2d94db52505c72ce90bc.woff2";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/RobotoLight.woff2
// module id = ../../../../../src/fonts/RobotoLight.woff2
// module chunks = 3